import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, X, Loader2 } from 'lucide-react';
import './InviteModal.css';

interface InviteModalProps {
  isOpen: boolean;
  email: string;
  isInviting: boolean;
  onClose: () => void;
  onEmailChange: (email: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function InviteModal({
  isOpen,
  email,
  isInviting,
  onClose,
  onEmailChange,
  onSubmit,
}: InviteModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-overlay">
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          <motion.div
            className="invite-modal"
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
          >
            {/* Header */}
            <div className="invite-modal__header">
              <div className="invite-modal__icon">
                <Mail size={22} />
              </div>
              <button className="invite-modal__close" onClick={onClose} aria-label="Close">
                <X size={18} />
              </button>
            </div>

            {/* Title */}
            <div className="invite-modal__title-block">
              <h2 className="invite-modal__title">Invite Team Member</h2>
              <p className="invite-modal__subtitle">
                Send an invitation to a colleague. They will receive an email with
                instructions to join your workspace.
              </p>
            </div>

            {/* Form */}
            <form className="invite-modal__form" onSubmit={onSubmit}>
              <div className="invite-modal__field">
                <label className="invite-modal__label" htmlFor="invite-email">
                  Email Address *
                </label>
                <div className="invite-modal__input-wrap">
                  <Mail size={15} className="invite-modal__input-icon" />
                  <input
                    id="invite-email"
                    type="email"
                    className="invite-modal__input"
                    placeholder="colleague@company.com"
                    value={email}
                    onChange={(e) => onEmailChange(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
              </div>

              <div className="invite-modal__actions">
                <button type="button" className="invite-modal__cancel" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="invite-modal__submit" disabled={isInviting}>
                  {isInviting ? <Loader2 size={15} className="animate-spin" /> : 'Send Invite'}
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
